import { render } from "./onBehalfOfNavbar.vue?vue&type=template&id=46c20f20&scoped=true&ts=true"
import script from "./onBehalfOfNavbar.vue?vue&type=script&lang=ts"
export * from "./onBehalfOfNavbar.vue?vue&type=script&lang=ts"

import "./onBehalfOfNavbar.vue?vue&type=style&index=0&id=46c20f20&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46c20f20"]])

export default __exports__